import { raterGuard } from './guards'
import type {
  RouteLocationNormalized as R,
  NavigationGuardNext as N,
  RouteRecordRaw
} from 'vue-router'
import { useLoadingStore } from '@/modules/core/stores/loadingStore'
import BranchEnum from '@/modules/core/models/BranchEnum'
import { useLifeStore as useRaterLifeStore } from '@/modules/life/rater/stores'
import { useLifeStore as useHiringLifeStore } from '@/modules/life/hiring/stores'
import ModifyInsuranceModal from '@/modules/life/rater/views/modals/ModifyInsuranceModal.vue'
import Step0Form from '@/modules/life/hiring/views/forms/Step0Form.vue'
import SpanishBranches from '@/modules/core/models/SpanishBranches'

const title = 'Seguros Médicos ASISA'
const branchName = BranchEnum.LIFE

const RATER_TITLE = 'Precios y Tarifas de los Seguros de Vida | ASISA'
const RATER_DESCRIPTION =
  'Descubre el precio de tu seguro de vida ASISA de forma fácil. Protege a tu familia con la mejor tarifa de seguros de vida.'

export const LIFE_RATER_ROUTES = [
  {
    path: SpanishBranches.life,
    name: 'rater-life',
    component: () => import('@/modules/common/rater/views/BaseView.vue'),
    meta: {
      title: RATER_TITLE,
      description: RATER_DESCRIPTION,
      branchName,
      defaultBusinessLineId: 'VI01'
    },
    props: () => ({
      store: useRaterLifeStore()
    }),
    beforeEnter: async (to: R, from: R, next: N) => {
      useLoadingStore().startLoading('common.loading.processing-almost-got-it')
      await raterGuard(to, from, next)
    }
  },
  {
    path: `${SpanishBranches.life}/:productCode/:clientCode`,
    name: 'life-product',
    component: () => import('@/modules/common/rater/views/ProductBaseView.vue'),
    meta: { title: RATER_TITLE, description: RATER_DESCRIPTION, branchName },
    props: () => ({
      store: useRaterLifeStore(),
      modifyModal: ModifyInsuranceModal
    }),
    beforeEnter: async (to: R, from: R, next: N) => {
      useLoadingStore().startLoading('common.loading.processing')
      await raterGuard(to, from, next)
    }
  },
  {
    path: `${SpanishBranches.life}/propuestas`,
    name: 'life-insurance-proposals',
    component: () => import('@/modules/common/rater/views/ProductProposalsView.vue'),
    meta: { title: RATER_TITLE, description: RATER_DESCRIPTION, branchName },
    props: () => ({
      store: useRaterLifeStore(),
      modifyModal: ModifyInsuranceModal
    }),
    beforeEnter: async (to: R, from: R, next: N) => {
      useLoadingStore().startLoading('common.loading.processing')
      await raterGuard(to, from, next)
    }
  }
] as RouteRecordRaw[]

export const LIFE_HIRING_ROUTES = [
  {
    path: `${SpanishBranches.life}/:id`,
    name: 'hiring-life',
    component: () => import('@/modules/common/hiring/views/BaseView.vue'),
    meta: { title, branchName, defaultBusinessLineId: 'VI01' },
    props: () => ({
      store: useHiringLifeStore(),
      repricingForm: Step0Form
    }),
    beforeEnter: (to: R, from: R, next: N) => {
      useLoadingStore().startLoading('common.loading.processing', 'common.loading.starting-hiring')
      raterGuard(to, from, next)
    }
  },
  {
    path: `${SpanishBranches.life}/completado/:hash`,
    name: 'life-hiring-done',
    meta: { title, branchName },
    component: () => import('../modules/common/hiring/views/EmittedView.vue'),
    props: {
      async emissionServiceCallback(quotationId: string) {
        return await useHiringLifeStore().emission(quotationId)
      },
      branchName
    }
  }
] as RouteRecordRaw[]
